// 📁 src/components/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [userPermissions, setUserPermissions] = useState(null); // ✅ EKLENDİ
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        try {
          const docRef = doc(db, "users", currentUser.email);
          const userDoc = await getDoc(docRef);

          if (userDoc.exists()) {
            const data = userDoc.data();
            setRole(data.role?.toLowerCase() || null);
            setUserPermissions(data || {}); // ✅ EKLENDİ
            console.log("📦 Firestore'dan gelen rol:", data.role);
            console.log("📦 Kullanıcı Yetkileri (fatura):", data.fatura);
          } else {
            setRole(null);
            setUserPermissions(null);
          }
        } catch (error) {
          console.error("❌ Kullanıcı verisi alınamadı:", error);
          setRole(null);
          setUserPermissions(null);
        }
      } else {
        setUser(null);
        setRole(null);
        setUserPermissions(null);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, role, userPermissions, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
